import { createAction, props } from '@ngrx/store';
import { StepsClientTypes, StepsNotClientTypes } from '../../shared/enums';

export const Navigate = createAction(
    '[Onboarding] Navigate to other page',
    props<{ step: StepsClientTypes | StepsNotClientTypes }>()
);

export const ToggleModal = createAction(
    '[Onboarding] Toggle Modal',
    props<{ open: boolean; text?: string; buttonText?: string; icon?: string; redirect?: StepsNotClientTypes | StepsClientTypes }>()
);

export const ModalResolution = createAction(
    '[Onboarding] Modal Resolution'
);

export const TagPage = createAction(
    '[Onboarding] tagging page',
    props<{ text: string; extras?: any }>()
);

export const TagPageSuccess = createAction(
    '[Onboarding] page tagged'
);

export const TagLogin = createAction(
    '[Onboarding] tagging login',
    props<{ params: any }>()
);

export const TagLoginSuccess = createAction(
    '[Onboarding] login tagged'
);
